module.exports = __webpack_public_path__ + "static/media/point-up.65a94756.mp3";